module.exports = __webpack_public_path__ + "img/head-shoulders_active.bc6bb4ba.png";